import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

function GoogleBtn({ onClick }) {
  return (
    <button data-testid="google-login" onClick={onClick} type="button"
      className="flex w-full items-center justify-center gap-3 rounded-full border border-[#DDDAD1] bg-black/[0.04] py-3 text-sm font-medium hover:bg-black/[0.05]">
      <svg className="h-4 w-4" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22 22-9.8 22-22c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 4.1 29.6 2 24 2 15.6 2 8.3 6.8 6.3 14.7z"/><path fill="#4CAF50" d="M24 46c5.5 0 10.4-2.1 14.1-5.5l-6.5-5.5C29.6 36.5 26.9 37.5 24 37.5c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C8.2 41.1 15.5 46 24 46z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.5l6.5 5.5C41.4 36 44 30.6 44 24c0-1.3-.1-2.3-.4-3.5z"/></svg>
      Continue with Google
    </button>
  );
}

export default function Login() {
  const { login, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/dashboard"); }
    catch (e) { setErr(apiError(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <main className="mx-auto flex max-w-md flex-col px-5 py-16">
      <div className="mb-6 flex items-center gap-2">
        <span className="grid h-9 w-9 place-items-center rounded-lg bg-teal-500 text-white"><ShieldCheck className="h-5 w-5" /></span>
        <span className="font-heading text-xl font-bold">Welcome back</span>
      </div>
      <div className="card-surface p-7">
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Email</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 border-[#DDDAD1] bg-ink-900" required /></div>
          <div><Label>Password</Label><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 border-[#DDDAD1] bg-ink-900" required /></div>
          {err && <p data-testid="login-error" className="text-sm text-coral-500">{err}</p>}
          <button data-testid="login-submit" disabled={loading} className="btn-teal w-full disabled:opacity-50">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
        <div className="my-5 flex items-center gap-3 text-xs text-slate-500"><div className="h-px flex-1 bg-black/[0.05]" />OR<div className="h-px flex-1 bg-black/[0.05]" /></div>
        <GoogleBtn onClick={loginWithGoogle} />
        <p className="mt-6 text-center text-sm text-slate-400">No account? <Link to="/register" className="text-teal-400 hover:text-teal-300">Create one</Link></p>
      </div>
    </main>
  );
}
